import React  from "react";

import { usePermission } from "imports/Utils";

import SalesCharterDetailsBlock from "./SalesCharterDetailsBlock";
import SalesCharterCreateBlock from "./SalesCharterCreateBlock";
import SalesCharterInfoBlock from "./SalesCharterInfoBlock";
import SalesCharterContactsBlock from "./SalesCharterContactsBlock";

import { Height, LoadingBlock } from "../Blocks";
import { getCharterTypeColor } from "view/charters/utils/CharterUtils";

import { SalesCharter, Voyage } from "types/index";

type UseSalesCharterBlockProps = {
	charter?: SalesCharter;
	voyage?: Voyage;
	loading: boolean;
	refetch: () => void;
	onAdd: (id: number) => void;
	onDelete: () => void;
};

const useSalesCharterBlock = ({ charter, voyage, loading, refetch, onAdd, onDelete }: UseSalesCharterBlockProps) => {

	const { isReadOnly } = usePermission();

	return {
		salesCharterBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Medium} />
				);
			} else if (charter) {
				return (
					<SalesCharterDetailsBlock
						charter={charter}
						color={getCharterTypeColor(charter.type, charter.subtype)}
						refetch={refetch}
						onDelete={onDelete} />
				);
			} else if (!isReadOnly) {
				return (
					<SalesCharterCreateBlock
						onAdd={(charterId: number) => onAdd(charterId)} />
				);
			} else {
				return <React.Fragment />;
			}
		}(),

		salesCharterInfoBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Auto} />
				);
			} else if (charter) {
				return (
					<SalesCharterInfoBlock
						charter={charter}
						voyage={voyage}
						color={getCharterTypeColor(charter.type, charter.subtype)} />
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),

		salesCharterContactsBlock: function() {
			if (loading) {
				return (
					<LoadingBlock
						height={Height.Medium} />
				);
			} else if (charter) {
				return (
					<SalesCharterContactsBlock
						charter={charter}
						color={getCharterTypeColor(charter.type, charter.subtype)}
						refetch={refetch} />
				);
			} else {
				return (
					<React.Fragment />
				);
			}
		}(),
	};
};

export default useSalesCharterBlock;
